class PremiumVisionStory extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    requestAnimationFrame(() => this.classList.add('is-ready'));

    if (this.dataset.reveal === 'true' && !this.reduceMotion && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: '100px 0px',
        threshold: 0.1,
      });
      this.observer.observe(this);
    } else {
      this.dataset.visible = 'true';
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  onIntersect = (entries) => {
    if (!entries[0]?.isIntersecting) return;
    this.dataset.visible = 'true';
    this.observer?.disconnect();
  };
}

if (!customElements.get('premium-vision-story')) {
  customElements.define('premium-vision-story', PremiumVisionStory);
}
